import React from "react";
import { ThreeCircles } from "react-loader-spinner";
import "./Loader.css"; // Import a CSS file for styling

const Loader = () => {
  return (
    <div className="loader-container">
      <ThreeCircles
        height={180}
        width={180}
        color="#1565c0"
        ariaLabel="three-circles-rotating"
        outerCircleColor=""
        innerCircleColor=""
        middleCircleColor=""
      />
    </div>
  );
};

export default Loader;
